import { DialogTitle } from '@efexteam/components';
import clsx from 'clsx';

export interface WooMomentsProps {
  title: string | React.ReactNode;
  icon: React.ReactNode;
  momentType: 'success' | 'info';
  onClose: () => void;
}

const WooMoments = ({ title, icon, momentType, onClose }: WooMomentsProps) => (
  <DialogTitle
    component="div"
    showCloseButton
    onClick={onClose}
    className={clsx(
      'min-h-[70px] flex items-center justify-start !text-white relative',
      momentType === 'success' ? '!bg-[#66BD58]' : '!bg-[#006BF8]'
    )}
  >
    <div className="border-r mr-3 pr-3">{icon}</div>
    {title}
  </DialogTitle>
);

export default WooMoments;
